import { ChevronDown } from '../../../components/ui/icons';

export function RelegationLine({ relegate }: { relegate: number }) {
  return (
    <div className="flex items-center gap-2 bg-danger/[0.06] px-[15px] py-[5px]">
      <div className="h-px flex-1 bg-danger/25" />
      <span className="inline-flex items-center gap-1 text-[9px] font-extrabold tracking-[0.1em] text-danger">
        <ChevronDown width={10} height={10} strokeWidth={3.4} />
        RELEGATION · BOTTOM {relegate}
      </span>
      <div className="h-px flex-1 bg-danger/25" />
    </div>
  );
}
